import React from 'react';
import {useFormContext} from "react-hook-form";

import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import {CertRenewalStep0, CertRenewalStep1, CertRenewalStep2, CertRenewalStep3, CertRenewalScheduleSummary} from './TaskCertificateRenewalStepsComponent';
import * as WFSteps from '../../constants/WorkflowSteps';
import * as Consts from '../../constants/Consts';
import { TaskStatus, TaskExamStatus } from '../../constants/Consts';
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as DateHelper from '../../util/DateHelper';


function CancelTaskDialog(props) {

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancelSubmit = () => {
        props.handleCancelTask();
        handleClose();
    }

    return(
        <React.Fragment>
            <Button sx={{ marginRight: 2 }} color="error" onClick={handleClickOpen} >Anuleaza</Button>
            <Dialog open={open} onClose={handleClose} maxWidth='md'>
                <DialogTitle>
                    Task
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                        >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                        Confirmati Anularea Taskului!
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Inchide</Button>
                    <Button onClick={handleCancelSubmit} color="error" >Anuleaza Task</Button>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    );
}



const BottomNavigationBar = (props) => {
    return(
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
            <Button
                color="inherit"
                disabled={props.activeStep === 0}
                onClick={props.handleBack}
                sx={{ mr: 1 }}
            >
                Inapoi
            </Button>

            <Box sx={{ flex: '1 1 auto' }} />

            <CancelTaskDialog handleCancelTask={props.handleCancelTask}/>
            <Button  type="submit">
                {props.activeStep === WFSteps.couponStampRenealSteps.length - 1 ? 'Finalizeaza' : 'Inainte'}
            </Button>
        </Box>
    );
}


export const TaskCertificateOrchestrator = (props) => {
    const {handleSubmit, reset, formState: { defaultValues }} = useFormContext();

    const [errMsg, setErrMsg] = React.useState(null);

    const handleCancelTask = () => {
        console.log('Cancel Task');

        const task = {
            id: defaultValues.lTask.id,
            details: defaultValues.lTask.details
        }
        task.details.status = TaskStatus.Cancelled;

        props.patchDeserventiTask(task);
    }

    const handleSubmitStep0 = (data) => {
        console.log("Submit Step 0");

        console.log(defaultValues.lTask.step0.scheduledDate);
        console.log(data.lTask.step0.scheduledDate);

        const origDate = DateHelper.getDateFromString(defaultValues.lTask.step0.scheduledDate).hour(0).minute(0).second(0).millisecond(0);
        const newDate = DateHelper.getDateFromString(data.lTask.step0.scheduledDate).hour(0).minute(0).second(0).millisecond(0);

        // const origDate = dayjs(`${defaultValues.lTask.step0.scheduledDate}`).hour(0).minute(0).second(0).millisecond(0);
        // const newDate = data.lTask.step0.scheduledDate.hour(0).minute(0).second(0).millisecond(0);


        if( !origDate.isSame(newDate) ) {    
            const task = {
                id: defaultValues.lTask.id,
                details: defaultValues.lTask.details,
                step0: data.lTask.step0
            }
            if(DateHelper.isRoLocaleStringDate(task.step0.scheduledDate)) 
                task.step0.scheduledDate =  DateHelper.getDateFromString(task.step0.scheduledDate).toISOString();

            props.patchDeserventiTask(task);
        }
        else {
            props.handleNext();
        }
        reset();
    }


    const handleSubmitStep1 = async (data) => {
        console.log("Submit Step 1");

        if( data.lTask.step1.scheduledReminders.length === 0) {
            setErrMsg( ValidationMessages.TASK_MIN_SELECTED_EMPLOYEES );
            return false;
        }
        else if( data.lTask.step1.scheduledReminders.length > 90) {
            setErrMsg( ValidationMessages.TASK_MAX_SELECTED_EMPLOYEES );
            return false;
        }

        if(data.lTask.details.activeStep === 1) {
            const task = getStep1Task(data);
            
            props.patchDeserventiTask(task);
        }
        else{
            if( hasStep1DataChanged(data.lTask.step1) ){
                const task = getStep1Task(data);

                const unschRems = getUnscheduledReminders(data.lTask.step1.scheduledReminders);
                if(unschRems.length > 0) {
                    task.unscheduled = {unscheduledReminders: unschRems}
                }

                props.patchDeserventiTask(task);
            }
            else{
                props.handleNext();
            }
        }

        reset();
    }

    const getStep1Task = (data) => {
        const task = {
            id: data.lTask.id,
            details: data.lTask.details,
            step1: data.lTask.step1
        }
        if(DateHelper.isRoLocaleStringDate(task.step1.newCertificateDate)) 
            task.step1.newCertificateDate =  DateHelper.getDateFromString(task.step1.newCertificateDate).toISOString();
        if(DateHelper.isRoLocaleStringDate(task.step1.dateFrom)) 
            task.step1.dateFrom =  DateHelper.getDateFromString(task.step1.dateFrom).toISOString();
        if(DateHelper.isRoLocaleStringDate(task.step1.dateTo)) 
            task.step1.dateTo =  DateHelper.getDateFromString(task.step1.dateTo).toISOString();

        task.step1.employerId = parseInt(task.step1.employerId);
        task.step1.workSiteId = parseInt(task.step1.workSiteId);
        task.details.activeStep = 2;

        const employer = props.employers.find((e) => e.id === task.step1.employerId)
        task.step1.employerName = employer.generalSection.employerName;

        return task;
    }

    const getUnscheduledReminders = (newScheduledRems) => {
        const unscheduledRems = [];
        defaultValues.lTask.step1.scheduledReminders.forEach(element => {
            if( !newScheduledRems.includes(element)){
                unscheduledRems.push(element);
            }
        });

        return unscheduledRems;
    }

    const hasStep1DataChanged = (step1) => {
        const origRsvtiOp = defaultValues.lTask.step1.operatorRsvtiUname;
        const origDateFrom = dayjs(`${defaultValues.lTask.step1.dateFrom}`).hour(0).minute(0).second(0).millisecond(0);
        const origDateTo = dayjs(`${defaultValues.lTask.step1.dateTo}`).hour(0).minute(0).second(0).millisecond(0);
        const origStampDate = dayjs(`${defaultValues.lTask.step1.newCertificateDate}`).hour(0).minute(0).second(0).millisecond(0);
        const newRsvtiOp = step1.operatorRsvtiUname;
        const newDateFrom = dayjs(`${step1.dateFrom}`).hour(0).minute(0).second(0).millisecond(0);
        const newDateTo = dayjs(`${step1.dateTo}`).hour(0).minute(0).second(0).millisecond(0);
        const newStampData = dayjs(`${step1.newCertificateDate}`).hour(0).minute(0).second(0).millisecond(0);

        if( origRsvtiOp == newRsvtiOp &&
            origDateFrom.isSame(newDateFrom) &&
            origDateTo.isSame(newDateTo) && 
            origStampDate.isSame(newStampData) &
            JSON.stringify(defaultValues.lTask.step1.scheduledReminders) === JSON.stringify(step1.scheduledReminders)) {

            return false;
        }
        else{
            return true;
        }
    }


    const handleSubmitStep2 = (data) => {
        console.log("Submit Step 2");
        props.handleNext();
    }



    const useConfirmDialog = () => {
        const [open, setOpen] = React.useState(false);
        const [saveCourseRegistration, setSaveCourseRegistration] = React.useState(null);
        const [course, setCourse] = React.useState(null);
    
        const openDialog = (saveCourse, updatedCourse) => {
            setSaveCourseRegistration(() => e => saveCourse(e));
            setCourse(updatedCourse);
            setOpen(true);
        };
        const handleClose = () => {
            setOpen(false);
        };
        const handleSubmit =() => {
            saveCourseRegistration(course);
        }
    
        const props = {
          open,
          handleClose,
          handleSubmit
        };
        return [openDialog, props];
    };
    
    
    const ConfirmCompleteTask = ({open, handleClose, handleSubmit}) => {
        console.log('__ ConfirmCompleteTask __');
    
        const handleConfirmSubmit = () => {
            handleClose();
            handleSubmit();
        }
    
        return(
            <React.Fragment>
                <Dialog open={open} onClose={handleClose} maxWidth='md'>
                    <DialogTitle>
                        Confirmare
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}
                            >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent dividers>
                        <Typography color="text.primary" paddingTop={1} paddingLeft={1}>
                            Confirmati finalizarea task-ului!
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Inchide</Button>
                        <Button onClick={handleConfirmSubmit} color="error" >Confirmare</Button>
                    </DialogActions>
                </Dialog>
    
            </React.Fragment>
        );
    }
    

    const handleSubmitStep3 = (data) => {
        console.log("Handle Submit Step 3");

        openConfirmDialog(handleSubmitStep3_orig, data);
    }

    const handleSubmitStep3_orig = (data) => {
        console.log("Submit Step 3");
        // check if it hasn't changed and updated if necessary

        const task = {
            id: data.lTask.id,
            details: data.lTask.details,
            step3: data.lTask.step3
        }
        task.details.activeStep = 4;
        task.details.status = TaskStatus.Completed;

        // New stamp date is going to match the scheduled date;
        // task.step3.newCertificateDate = defaultValues.lTask.step0.scheduledDate;

        const passedExam = task.step3.examParticipants.filter((participant) => participant.examResult === TaskExamStatus.Accepted)
                                                    .map((participant) => participant.id);

        const failedExam = task.step3.examParticipants.filter((participant) => participant.examResult != TaskExamStatus.Accepted)
                                                    .map((participant) => participant.id);

        props.patchDeserventiTask(task);
        props.patchAuthzsCertDate(task.id, defaultValues.lTask.details.clientId, defaultValues.lTask.step1.employerId, passedExam, failedExam, defaultValues.lTask.step1.newCertificateDate);
    }

    const [openConfirmDialog, confirmDialogProps] = useConfirmDialog();

    switch (props.activeStep) {
        case 0:
            return (
                <React.Fragment>
                    <form onSubmit={handleSubmit( handleSubmitStep0 )} id={'step0Form'}>
                        <CertRenewalStep0 />

                        <BottomNavigationBar 
                            activeStep={props.activeStep}
                            handleBack={props.handleBack}
                            handleCancelTask={handleCancelTask}
                        />
                    </form>
                </React.Fragment>
            );

        case 1:
            return (
                <React.Fragment>
                    <form onSubmit={handleSubmit( handleSubmitStep1 )} id={'step1Form'}>
                        <CertRenewalStep1 
                            employers={props.employers}
                            errMsg={errMsg}
                        />

                        <BottomNavigationBar 
                            activeStep={props.activeStep}
                            handleBack={props.handleBack}
                            handleCancelTask={handleCancelTask}
                        />
                    </form>
                </React.Fragment>
            );
        case 2:
            return (
                <form onSubmit={handleSubmit( handleSubmitStep2 )} id={'step2Form'}>
                    <CertRenewalStep2 
                    />

                    <BottomNavigationBar 
                        activeStep={props.activeStep}
                        handleBack={props.handleBack}
                        handleCancelTask={handleCancelTask}
                    />
                </form>
            );
        case 3:
            return (
                <form onSubmit={handleSubmit( handleSubmitStep3 )} id={'step3Form'}>
                    <ConfirmCompleteTask {...confirmDialogProps}/>

                    <CertRenewalStep3 
                    />

                    <BottomNavigationBar 
                        activeStep={props.activeStep}
                        handleBack={props.handleBack}
                        handleCancelTask={handleCancelTask}
                    />
                </form>
            );
        case 4:
            return (
                <CertRenewalScheduleSummary />
            );
    }
}
